{
  "name": "@uppy/facebook",
  "description": "Import files from Facebook, into Uppy.",
  "version": "5.0.1",
  "license": "MIT",
  "type": "module",
  "sideEffects": false,
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "uppy",
    "uppy-plugin",
    "facebook"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "exports": {
    ".": "./lib/index.js",
    "./package.json": "./package.json"
  },
  "dependencies": {
    "@uppy/companion-client": "workspace:^",
    "@uppy/provider-views": "workspace:^",
    "@uppy/utils": "workspace:^",
    "preact": "^10.5.13"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "typescript": "^5.8.3"
  }
}
